import script from "./CancelarAplicacao.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelarAplicacao.vue?vue&type=script&setup=true&lang=js"

import "./CancelarAplicacao.vue?vue&type=style&index=0&id=2964a9d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2964a9d7"]])

export default __exports__